module.exports = __webpack_public_path__ + "static/image2-2dfa38ed14fb4c71cb18d19467324e23.jpg";